import ZkMessageAnnSaveOrUpdate from './src/main.vue'
ZkMessageAnnSaveOrUpdate.install = function (Vue) {
  Vue.component(ZkMessageAnnSaveOrUpdate.name, ZkMessageAnnSaveOrUpdate)
}

export default ZkMessageAnnSaveOrUpdate



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/messageAnnSaveOrUpdate/index.js